export const categories = [
  {
    slug: 'qipa-renwu',
    name: '奇葩人物',
    desc: '总有人能把普通的一天，过成让人反复回放的名场面。',
    icon: 'ri-user-star-line',
    count: 128,
  },
  {
    slug: 'mihuo-xingwei',
    name: '迷惑行为',
    desc: '看不懂，但我大受震撼。每一个操作都值得暂停三秒。',
    icon: 'ri-question-line',
    count: 214,
  },
  {
    slug: 'shadiao-xinwen',
    name: '沙雕新闻',
    desc: '不严肃、不装腔，只负责让你笑出声的那部分新闻。',
    icon: 'ri-newspaper-line',
    count: 176,
  },
  {
    slug: 'lipu-gushi',
    name: '离谱故事',
    desc: '现实比剧本敢写，起因经过结果全都出乎意料。',
    icon: 'ri-book-open-line',
    count: 143,
  },
  {
    slug: 'gaoxiao-guaishi',
    name: '搞笑怪事',
    desc: '小事一桩，笑点拉满，看完只想说一句"还能这样"。',
    icon: 'ri-emotion-laugh-line',
    count: 198,
  },
  {
    slug: 'mohuan-xianshi',
    name: '魔幻现实',
    desc: '魔幻操作与真实生活同框，看完只想确认一下是不是真的。',
    icon: 'ri-magic-line',
    count: 89,
  },
];